export enum CRUDPathSegmentEn {
  ADD = '/add',
  EDIT = '/edit',
  DETAIL = '/detail',
  DETAIL_BY_CODE = '/detail-by-code',
  QR = '/qr'
}
